/**
 * Feedback utilities for sound and haptic responses
 */

// Generate a short beep tone using Web Audio API
const playTone = (frequency = 800, duration = 150, volume = 0.3, type = 'sine') => {
    try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);

        oscillator.type = type;
        oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime);

        // Fade in
        gainNode.gain.setValueAtTime(0, audioContext.currentTime);
        gainNode.gain.linearRampToValueAtTime(volume, audioContext.currentTime + 0.01);
        // Fade out
        gainNode.gain.linearRampToValueAtTime(0, audioContext.currentTime + duration / 1000);

        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + duration / 1000);

        // Clean up
        setTimeout(() => audioContext.close(), duration + 100);
    } catch (e) {
        // Audio not supported, silently fail
        console.warn('Audio feedback not available:', e.message);
    }
};

// Trigger haptic vibration if supported
const vibrate = (pattern = [50]) => {
    try {
        if (navigator.vibrate) {
            navigator.vibrate(pattern);
        }
    } catch (e) {
        // Vibration not supported
    }
};

/**
 * Sale completion feedback - cheerful double beep + vibration
 */
export const saleCompleteFeedback = () => {
    // Double ascending tone
    playTone(600, 100, 0.25, 'sine');
    setTimeout(() => playTone(900, 150, 0.25, 'sine'), 120);
    // Short vibration
    vibrate([50, 30, 50]);
};

/**
 * Item added to cart feedback - quick tap
 */
export const addToCartFeedback = () => {
    playTone(500, 60, 0.15, 'sine');
    vibrate([30]);
};

/**
 * Delete/remove feedback - low tone
 */
export const deleteFeedback = () => {
    playTone(300, 100, 0.2, 'triangle');
    vibrate([100]);
};

/**
 * Undo feedback - reverse tone
 */
export const undoFeedback = () => {
    playTone(700, 80, 0.2, 'sine');
    setTimeout(() => playTone(500, 100, 0.2, 'sine'), 90);
    vibrate([30, 20, 30]);
};

/**
 * Error feedback - buzz
 */
export const errorFeedback = () => {
    playTone(200, 200, 0.2, 'square');
    vibrate([100, 50, 100]);
};
